import { render, staticRenderFns } from "./ProjectRegister.vue?vue&type=template&id=591ec045&scoped=true&"
import script from "./ProjectRegister.vue?vue&type=script&lang=js&"
export * from "./ProjectRegister.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRegister.vue?vue&type=style&index=0&id=591ec045&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591ec045",
  null
  
)

export default component.exports